/**
 * CompanySubHeader — sub-header content for an ahoy_company slideout.
 *
 * Layout: `Domain | City, Country`. Registered on
 * `ENTITY_TYPE_REGISTRY.ahoy_company.components.subHeader`. Consumers should
 * go through `SubHeaderSection`.
 */

import type { CrmObject } from '@/types/crm';
import { getPropertyValue } from '@/types/crm';

import { SubHeaderLayout } from './sub-header-layout';

export function CompanySubHeader({ object }: { object: CrmObject }) {
  const domain = getPropertyValue<string>(object.properties?.ahoy_domain);
  const city = getPropertyValue<string>(object.properties?.ahoy_city);
  const country = getPropertyValue<string>(object.properties?.ahoy_country);

  const location = [city, country].filter(Boolean).join(', ');

  return (
    <SubHeaderLayout
      primary={domain ? <span>{domain}</span> : undefined}
      secondary={location ? <span>{location}</span> : undefined}
    />
  );
}
